import React, {useState} from "react"
import {KeyEvent, ProcessedEventV2} from "../../../dtos/eventResponse"
import EventsToolbar from "./EventsToolbar"
import EventsTable from "./EventsTable"
import {processEventsDataV2} from "../../../processor/eventProcessor"
import {makeStyles} from "tss-react/mui"

interface EventAccordionDetailsProps {
	events: KeyEvent[]
}
const useStyles = makeStyles()({
	container: {
		display: "flex",
		paddingBottom: "24px",
		flexDirection: "column",
		alignItems: "flex-end",
		gap: "24px",
		alignSelf: "stretch",
		width: "100%",
	},
})
export default function EventAccordionDetails(props: EventAccordionDetailsProps) {
	const {classes} = useStyles()
	const [searchText, setSearchText] = useState("")
	const [eventsType, setEventsType] = useState("keyEvents")
	const allEvents = processEventsDataV2(props.events)
	const getKeyEvents = () => {
		return allEvents.filter((event) => ["success", "update", "warning"].includes(event.tag))
	}
	const [displayedEvents, setDisplayedEvents] = useState<ProcessedEventV2[]>(getKeyEvents())
	const updateSearchText = (newSearchText: string) => {
		setSearchText(newSearchText)
		updateDisplayedEvents(eventsType, newSearchText)
	}
	const updateEventsType = (newEventsType: string) => {
		setEventsType(newEventsType)
		updateDisplayedEvents(newEventsType, searchText)
	}

	const getEventsByEventType = (eventsType: string): ProcessedEventV2[] => {
		switch (eventsType) {
			case "allEvents":
				return allEvents
			case "keyEvents":
				return getKeyEvents()
			case "warnings":
				return allEvents.filter((event) => event.tag === "warning")
			case "updates":
				return allEvents.filter((event) => event.tag === "update")
		}
		return []
	}
	const updateDisplayedEvents = (eventsType: string, searchText: string) => {
		const filteredEventsByEventType = getEventsByEventType(eventsType)
		const searchTermInLowerCase = searchText.toLowerCase()
		if (!searchText || searchText !== "") {
			const filteredEventsBySearchTerm = filteredEventsByEventType.filter(
				(event) =>
					(event.delayedReason &&
						event.delayedReason.toLowerCase().includes(searchTermInLowerCase)) ||
					(event.description && event.description.toLowerCase().includes(searchTermInLowerCase)) ||
					(event.eventSubType &&
						event.eventSubType.toLowerCase().includes(searchTermInLowerCase)) ||
					(event.reason && event.reason.toLowerCase().includes(searchTermInLowerCase)) ||
					(event.source && event.source.toLowerCase().includes(searchTermInLowerCase)) ||
					(event.type && event.type.toLowerCase().includes(searchTermInLowerCase)) ||
					(event.dateTime && event.dateTime.toLowerCase().includes(searchTermInLowerCase)) ||
					(event.updatedArrivalDate &&
						event.updatedArrivalDate.toLowerCase().includes(searchTermInLowerCase))
			)
			setDisplayedEvents(filteredEventsBySearchTerm)
		} else {
			setDisplayedEvents(filteredEventsByEventType)
		}
	}
	return (
		<div className={classes.container}>
			<EventsToolbar
				eventType={eventsType}
				searchText={searchText}
				updateSearchText={updateSearchText}
				updateEventsType={updateEventsType}
			/>
			<EventsTable events={displayedEvents} />
		</div>
	)
}
